import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";

export interface IStaffMember {
  id: number;
  company_id: number;
  role_id: number;
  role_slug: string;
  role_name: string;
  email: string | null;
  phone: string | null;
  mobile: string | null;
  first_name: string | null;
  last_name: string | null;
  job_title: string | null;
  employee_number: string | null;
  employment_type: string | null;
  hourly_rate: number | null;
  postcode: string | null;
  start_date: string | null;
  end_date: string | null;
  status: "ACTIVE" | "INACTIVE";
  created_at: string;
}

export const listStaff = (params: any): Promise<AxiosResponse<TResponseWithQData<IStaffMember[]>>> =>
  axios.get(API_ENDPOINTS.STAFF_LIST, { params });

export const getStaffMember = (id: number): Promise<AxiosResponse<TResponse<IStaffMember>>> =>
  axios.get(`${API_ENDPOINTS.STAFF_DETAIL}/${id}`);

export const createStaffMember = (data: any): Promise<AxiosResponse<TResponse<IStaffMember>>> =>
  axios.post(API_ENDPOINTS.STAFF_CREATE, data);

export const updateStaffMember = (data: any): Promise<AxiosResponse<TResponse<IStaffMember>>> =>
  axios.post(API_ENDPOINTS.STAFF_UPDATE, data);

export const deleteStaffMember = (id: number): Promise<AxiosResponse<TResponse<null>>> =>
  axios.post(API_ENDPOINTS.STAFF_DELETE, { id });
